import '../node_modules/bootstrap/scss/bootstrap.scss' 
import './assets/offlinePrototype.css'
import React, { useState, useEffect, useRef } from 'react';
import {Link, Routes, Route, useLocation} from 'react-router-dom'
import { createPopper } from '@popperjs/core';


// import logo from './logo.svg';
import bg from './img/bg.png';
import productos from './img/productos.gif'
import digital from './img/digital.gif'
import './App.css';

// import Breadcrumbs from './Breadcrumbs'
import Nav from './Nav'

import Velocity from 'velocity-animate';

function App() {

  const tip = useRef();

  const iframeRef = useRef();

  const location = useLocation();

  let texts = [
    {
      "Screen Name": 1664389020056,
      "Name": "Pablo Covacevich",
      "Message": "¡¡Tu pedido ha sido ingresado!!\nPuedes agregar otro, o volver al inicio.",
      "Link": 88906992,
      "Date": "2022-09-28 18:13:44",
      "Img": "images/2b69ca9e624e41aabd31ce305b415b2f.jpg"
    },
    {
      "Screen Name": 1664389020098,
      "Name": "Pablo Covacevich",
      "Message": "Acá puedes indicar un correo adicional para el envío del comprobante de pedido.",
      "Link": 88906990,
      "Date": "2022-09-28 18:12:39",
      "Img": "images/ffa4a075b814977bb138e27a7e3eb00.jpg"
    },
    {
      "Screen Name": 1664389020117,
      "Name": "Pablo Covacevich",
      "Message": "Verás un resumen del pedido, si estás de acuerdo presiona \"continuar\".",
      "Link": 88906989,
      "Date": "2022-09-28 18:12:11",
      "Img": "images/bdd7341cf86a461abffe9df8732f60c4.jpg"
    },
    {
      "Screen Name": 1664389020137,
      "Name": "Pablo Covacevich",
      "Message": "Se debe indicar los datos del contacto en obra.",
      "Link": 88906988,
      "Date": "2022-09-28 18:11:43",
      "Img": "images/0389762b71c48bab918520abe606703.jpg"
    },
    {
      "Screen Name": 1664389020159,
      "Name": "Pablo Covacevich",
      "Message": "Si la orden de compra tiene contratado servicio de bombeo y/o muestra podrás indicar si lo quieres agregar al despacho.\n\nAdemás puedes agregar observaciones asociadas al despacho.",
      "Link": 88906987,
      "Date": "2022-09-28 18:11:12",
      "Img": "images/6cdd5433bc146bc80d86a435b81be18.jpg"
    },
    {
      "Screen Name": 1664389020180,
      "Name": "Pablo Covacevich",
      "Message": "Si la orden de compra tiene contratado servicio de bombeo y/o muestra podrás indicar si lo quieres agregar al despacho.\nAdemás puedes agregar observaciones asociadas al despacho.",
      "Link": 88906984,
      "Date": "2022-09-28 18:10:52",
      "Img": "images/8e01311a4baa4791965c05b60c1f0431.jpg"
    },
    {
      "Screen Name": 1664389020202,
      "Name": "Pablo Covacevich",
      "Message": "Luego indicar la frecuencia del despacho.",
      "Link": 88906983,
      "Date": "2022-09-28 18:09:28",
      "Img": "images/161e83d817c2438bb3c24fecaaf7207d.jpg"
    },
    {
      "Screen Name": 1664389020223,
      "Name": "Pablo Covacevich",
      "Message": "La hora de inicio del despacho se puede indicar dentro del bloque.",
      "Link": 88906982,
      "Date": "2022-09-28 18:08:53",
      "Img": "images/0a9670b8952d482d93e2d53980b42ca6.jpg"
    },
    {
      "Screen Name": 1664389020264,
      "Name": "Pablo Covacevich",
      "Message": "Para seleccionar el día y horario se mostrará en bloques el nivel de saturación de la planta mediante colores.",
      "Link": 88907296,
      "Date": "2022-09-28 18:08:22",
      "Img": "images/1ce8294877ad49de8ac50f79826329f1.png"
    },
    {
      "Screen Name": 1664389020284,
      "Name": "Pablo Covacevich",
      "Message": "Indica el volumen solicitado, y se te dará el número de camiones estimado al despacho.",
      "Link": 88906979,
      "Date": "2022-09-28 18:05:46",
      "Img": "images/8f805b8953d1416ba710867bfdbab632.jpg"
    },
    {
      "Screen Name": 1664389020304,
      "Name": "Pablo Covacevich",
      "Message": "Verás los saldos del producto en las ordenes de compra disponibles",
      "Link": 88906977,
      "Date": "2022-09-28 18:03:46",
      "Img": "images/1ebbabc02c234fc1a89b13b12fe75eb8.jpg"
    },
    {
      "Screen Name": 1664389020325,
      "Name": "Pablo Covacevich",
      "Message": "Elige el producto deseado",
      "Link": 88906975,
      "Date": "2022-09-28 18:02:56",
      "Img": "images/82e609dacfc246418f751483e402a9ef.jpg"
    },
    {
      "Screen Name": 1664389020344,
      "Name": "Pablo Covacevich",
      "Message": "Para programar selecciona un producto",
      "Link": 88906972,
      "Date": "2022-09-28 18:02:33",
      "Img": "images/3922f0499aba4843a22531015568e48a.jpg"
    },
    {
      "Screen Name": 1664293319516,
      "Name": "Pablo Covacevich",
      "Message": "¡Gracias por tu evaluación!",
      "Link": 88886659,
      "Date": "2022-09-28 17:54:34",
      "Img": "images/60f7450a5b8b462887cc74987ce3e75e.jpg"
    },
    {
      "Screen Name": 1664293319532,
      "Name": "Pablo Covacevich",
      "Message": "Y evalúanos.",
      "Link": 88886660,
      "Date": "2022-09-28 17:54:20",
      "Img": "images/8f36d12f764964937c0c5d6c8bf536.jpg"
    },
    {
      "Screen Name": 1664293319552,
      "Name": "Pablo Covacevich",
      "Message": "Ahora puedes seleccionar el área que te gustaría destacar.",
      "Link": 88886661,
      "Date": "2022-09-28 17:54:08",
      "Img": "images/701def2669374c758e986850e16802d4.jpg"
    },
    {
      "Screen Name": 1664293319570,
      "Name": "Pablo Covacevich",
      "Message": "Luego del Despacho puedes evaluarlo con una escala de 5 estrellas.",
      "Link": 88886662,
      "Date": "2022-09-28 17:53:50",
      "Img": "images/75a71cd4ddf44569853a51d276417591.jpg"
    },
    {
      "Screen Name": 1664288324001,
      "Name": "Pablo Covacevich",
      "Message": "Ahora puedes enviar la Firma y se recepciona la Guía.",
      "Link": 88886588,
      "Date": "2022-09-28 17:53:29",
      "Img": "images/98bfb5dfa284df0ba927136301c9fad.jpg"
    },
    {
      "Screen Name": 1664288324017,
      "Name": "Pablo Covacevich",
      "Message": "Firma la Recepción!",
      "Link": 88886589,
      "Date": "2022-09-28 17:53:07",
      "Img": "images/c870038dfc944747ac62b473569cf60b.jpg"
    },
    {
      "Screen Name": 1664288324034,
      "Name": "Pablo Covacevich",
      "Message": "Agrega los datos del receptor firmante, e información del despacho.",
      "Link": 88886590,
      "Date": "2022-09-28 17:52:18",
      "Img": "images/c696b38b3bef4222a819a75e2e54ff25.jpg"
    },
    {
      "Screen Name": "1664286465068 copy",
      "Name": "Pablo Covacevich",
      "Message": "Consultar la información del despacho antes de la firma",
      "Link": 88887309,
      "Date": "2022-09-28 17:51:14",
      "Img": "images/89a37ccbfa9c4271a3a174693cb875e7.jpg"
    },
    {
      "Screen Name": "1664286465084 copy",
      "Name": "Pablo Covacevich",
      "Message": "Podrás consultar el detalle de la guias de despacho, ver el PDF de la guia electrónica, y el Sello Digital.\nPuedes Revisar lo que quieras antes de la Firma Digital.",
      "Link": 88887282,
      "Date": "2022-09-28 17:47:54",
      "Img": "images/38e3be91e8a74c6bba24b8aa765a6eaf.jpg"
    },
    {
      "Screen Name": 1664288324055,
      "Name": "Pablo Covacevich",
      "Message": "Podemos ver las guias activas del día, ya sea para consultar su detalle, como para firmas pendientes.",
      "Link": 88886591,
      "Date": "2022-09-28 17:45:29",
      "Img": "images/051610d434f7435e8695058c5785f8cd.jpg"
    },
    {
      "Screen Name": 1664286464881,
      "Name": "Pablo Covacevich",
      "Message": "En esta sección podrás revisar la evaluación estadística de tu obra, y generar curvas teóricas de resistencia.",
      "Link": 88886128,
      "Date": "2022-09-28 17:44:30",
      "Img": "images/21011bd81fca41409f3fd7e8c773da7c.jpg"
    },
    {
      "Screen Name": 1664286464898,
      "Name": "Pablo Covacevich",
      "Message": "El acceso al portal de asesoría técnica donde podrás tener acceso a información técnica y charlas especiales.",
      "Link": 88886129,
      "Date": "2022-09-28 17:43:35",
      "Img": "images/46eada2256c94415ab3e8fd5800b9ab3.jpg"
    },
    {
      "Screen Name": 1664286464917,
      "Name": "Pablo Covacevich",
      "Message": "Acá podrás configurar las obras que quieres tener disponible para consulta, y configurar si quieres recibir la notificaciones por cada obra.",
      "Link": 88886130,
      "Date": "2022-09-28 17:42:58",
      "Img": "images/6dfc06fdddcc455c832c3cb354c0f96d.jpg"
    },
    {
      "Screen Name": 1664286464933,
      "Name": "Pablo Covacevich",
      "Message": "Se puede ver el detalle de Volumen de Producto por Orden de Compra.",
      "Link": 88886131,
      "Date": "2022-09-28 17:40:49",
      "Img": "images/06365145a5f425298dddae7b616873a.jpg"
    },
    {
      "Screen Name": 1664286464951,
      "Name": "Pablo Covacevich",
      "Message": "Muestra el volumen original, despachado y saldo de productos por orden de compra.\nSi presionas Producto, la vista cambia a por producto.",
      "Link": 88886132,
      "Date": "2022-09-28 17:38:55",
      "Img": "images/3039dd2fef334a20a092d5273ba63d5a.jpg"
    },
    {
      "Screen Name": 1664286464967,
      "Name": "Pablo Covacevich",
      "Message": "Puedes ver el volumen despachado de productos de las ordenes de compra, y consultar el crédito.",
      "Link": 88886133,
      "Date": "2022-09-28 17:37:11",
      "Img": "images/c5907483b9a43a09a803f795a562d3a.jpg"
    },
    {
      "Screen Name": 1664286464984,
      "Name": "Pablo Covacevich",
      "Message": "En este menú podrás consultar Indicadores, Guias Pendientes, la configuración de obras, entre otros.",
      "Link": 88886134,
      "Date": "2022-09-28 17:36:06",
      "Img": "images/4af7b94819f14d309c04833ee3cfb84c.jpg"
    },
    {
      "Screen Name": 1664286465017,
      "Name": "Pablo Covacevich",
      "Message": "Puedes ver la programación de cualquier día.",
      "Link": 88886136,
      "Date": "2022-09-28 17:35:20",
      "Img": "images/93528214371d4156b3728b78543b3f2d.png"
    },
    {
      "Screen Name": 1664286465034,
      "Name": "Pablo Covacevich",
      "Message": "Puedes ver la programación de cualquier día.",
      "Link": 88886137,
      "Date": "2022-09-28 17:35:16",
      "Img": "images/42d6d97875b64c90858dc40ddfde5c85.png"
    },
    {
      "Screen Name": 1664286465051,
      "Name": "Pablo Covacevich",
      "Message": "Puedes ver la programación de cualquier día.",
      "Link": 88886138,
      "Date": "2022-09-28 17:35:09",
      "Img": "images/4b60b1c35dec48b3935b05aa2d73f600.png"
    },
    {
      "Screen Name": 1664292722512,
      "Name": "Pablo Covacevich",
      "Message": "El Sello Digital muestra la ruta real del camión a la obra, indicando desvios o descargas en el camino.",
      "Link": 88886502,
      "Date": "2022-09-28 17:34:41",
      "Img": "images/55419e336d16430c9b3283e45f41d244.jpg"
    },
    {
      "Screen Name": 1664286465068,
      "Name": "Pablo Covacevich",
      "Message": "Verás la guia de despacho electrónica. Una vez firmada, la verás con la información completada de horas y firma.",
      "Link": 88886139,
      "Date": "2022-09-28 17:33:09",
      "Img": "images/89a37ccbfa9c4271a3a174693cb875e7.jpg"
    },
    {
      "Screen Name": 1664286465084,
      "Name": "Pablo Covacevich",
      "Message": "La guia muestra la información del despacho.\nPuedes ver el PDF de la guia electrónica.\nPuedes ver el Sello Digital del despacho.",
      "Link": 88886140,
      "Date": "2022-09-28 17:32:28",
      "Img": "images/38e3be91e8a74c6bba24b8aa765a6eaf.jpg"
    },
    {
      "Screen Name": 1664286465001,
      "Name": "Pablo Covacevich",
      "Message": "Podrás ver el detalle de un pedido",
      "Link": 88886135,
      "Date": "2022-09-28 17:31:05",
      "Img": "images/69f47e8709ba45d3882a280b74f892d2.png"
    },
    {
      "Screen Name": 1664292459538,
      "Name": "Pablo Covacevich",
      "Message": "Verás el detalle de los despachos por pedido con sus estados y número de guia.\nPresiona una guía para ver el detalle.",
      "Link": 88886463,
      "Date": "2022-09-28 17:30:41",
      "Img": "images/3f8742c1ce0d476ebdb06edc9af7c323.png"
    },
    {
      "Screen Name": 1664286465101,
      "Name": "Pablo Covacevich",
      "Message": "Puedes ver los pedidos programados del día. Si presionas el pedido puedes ver el detalle.\nTambien puedes cambiar el día.",
      "Link": 88886141,
      "Date": "2022-09-28 17:29:19",
      "Img": "images/cc92b8e361924b808e69f040856fca3e.png"
    },
    {
      "Screen Name": 1664286465117,
      "Name": "Pablo Covacevich",
      "Message": "Puedes ver de manera gráfica como se distribuye el desapcho en el día.",
      "Link": 88886142,
      "Date": "2022-09-28 17:26:20",
      "Img": "images/53d29d527c7542d0bbb83ad16a405adf.png"
    },
    {
      "Screen Name": 1664286465133,
      "Name": "Pablo Covacevich",
      "Message": "Puedes ver los despachos programadados de cada día",
      "Link": 88886143,
      "Date": "2022-09-28 17:25:42",
      "Img": "images/8cd53f35069644f3aa072f26e8f15554.png"
    },
    {
      "Screen Name": 1664286465150,
      "Name": "Pablo Covacevich",
      "Message": "Puedes realizar seguimiento GPS en línea de los camiones en ruta a la obra.\nEn Programación podrás ver los despachos de la semana",
      "Link": 88885731,
      "Date": "2022-09-28 17:24:43",
      "Img": "images/3ebe1e85ff64e78836b3624608b2e87.jpg"
    },
    {
      "Screen Name": 1664286465167,
      "Name": "Pablo Covacevich",
      "Message": "Bienvenido a MiObra.\nPresiona para continuar...",
      "Link": 88885728,
      "Date": "2022-09-28 17:01:14",
      "Img": "images/1f9a996ace1c4811897ae0745ad12bd7.jpg"
    }
  ]  

  useEffect(() => {

    setTimeout(() => {
      Velocity(document.getElementById('tooltip'), {opacity: 1}, {duation: 250});
    }, 1500);

  }, [])

  useEffect(() =>{

    let currentHash = location.hash.split('/');
    let currentLink = location.hash.split('/')[currentHash.length-1];
    
    for (let i=0; i<texts.length; i++) {
      if (texts[i].Link == currentLink) {
        tip.current.innerHTML = texts[i].Message
      }
    }


  }, [location])

  return (
    <div className="App container-fluid g-0 fullvh">

      <div className="row g-0">

        <img src={productos} className="bg" />

        <div id="tooltip" role="tooltip fullvh d-none">
          <p ref={tip}></p>
        </div>

        <div className="row g-0 fullvh">

          <div className="col-1 g-0">
            <Nav />
          </div>

          <div className=" col-11 fullvh">

            <iframe ref={iframeRef} className="iframe-conoce" width="1800" height="1080"  src="./marvelapp/index.html"></iframe>
            
          </div>          
          
        </div>

      </div>

    </div>
  );
}

export default App;
